import React from "react";

const LoaderComponent = () => {
    return (
        <div className="flex h-screen w-full justify-center items-center fixed top-0 left-0 z-30 loader-bg w-[100vw]">
            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500 border-solid mt-10"></div>
        </div>
    );
};

export default LoaderComponent;
